var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeasePortfolioSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Lease_Portfolio_Setup"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lease_Portfolio_Setup",
    "data-name": "Lease Portfolio Setup",
    clipPath: "url(#clip-Lease_Portfolio_Setup)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11755",
    "data-name": "Group 11755",
    transform: "translate(0.673 0.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11756",
    "data-name": "Group 11756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22182",
    "data-name": "Path 22182",
    d: "M0,.814A.993.993,0,0,1,.464.158,1.341,1.341,0,0,1,1.019.007Q6.9-.006,12.784,0A.971.971,0,0,1,13.8,1.016c0,1.144,0,2.289,0,3.433,0,.237-.13.389-.323.39s-.326-.151-.326-.387q0-1.676,0-3.351c0-.343-.105-.449-.446-.449H1.1C.758.651.651.757.651,1.1q0,7.232,0,14.463c0,.351.1.452.459.452H12.7c.351,0,.454-.1.454-.458,0-.732,0-1.464,0-2.2,0-.245.138-.4.338-.391s.311.154.312.384c0,.472,0,.944,0,1.415q0,.407,0,.813a.977.977,0,0,1-.773,1.058.2.2,0,0,0-.041.025H.814c-.085-.033-.172-.061-.254-.1A1.061,1.061,0,0,1,0,15.849Z",
    transform: "translate(0 0)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22183",
    "data-name": "Path 22183",
    d: "M302.688,124.682a1.406,1.406,0,0,1,1.372,2.112c-.8,1.358-1.578,2.728-2.366,4.093-.539.933-1.075,1.868-1.62,2.8a1.128,1.128,0,0,1-.288.321q-.935.7-1.885,1.388a.592.592,0,0,1-.308.117.3.3,0,0,1-.283-.363c.031-.362.074-.722.114-1.083.05-.452.1-.905.155-1.356a.968.968,0,0,1,.111-.351q1.993-3.464,3.994-6.924a1.342,1.342,0,0,1,1-.753m-1.041,2.121-3.288,5.692,1.241.715,3.286-5.691-1.239-.717m1.57.155a7.482,7.482,0,0,0,.367-.68.7.7,0,0,0-.327-.862.7.7,0,0,0-.913.2c-.135.194-.245.405-.373.62l1.247.72m-5.184,7.536,1.092-.8-.941-.543-.151,1.347",
    transform: "translate(-287.615 -120.617)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22184",
    "data-name": "Path 22184",
    d: "M125.8,56.919a2.994,2.994,0,1,1-2.986-3,3,3,0,0,1,2.986,3m-1.119,1.373a2.332,2.332,0,1,0-3.747-.006,2.394,2.394,0,0,1,.947-.787,1.368,1.368,0,0,1-.246-.92,1.173,1.173,0,1,1,2.345.008,1.391,1.391,0,0,1-.246.915,2.328,2.328,0,0,1,.948.79m-3.281.477a2.291,2.291,0,0,0,2.812,0,1.629,1.629,0,0,0-2.812,0m1.933-2.086h-.008c0-.043,0-.087,0-.13a.515.515,0,0,0-.471-.493.5.5,0,0,0-.548.4,1.253,1.253,0,0,0,0,.449.5.5,0,0,0,.507.4.517.517,0,0,0,.493-.4,1.656,1.656,0,0,0,.024-.225",
    transform: "translate(-115.904 -52.163)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22185",
    "data-name": "Path 22185",
    d: "M116.537,270.138h-2.2a.773.773,0,0,1-.193-.019.311.311,0,0,1-.237-.311.306.306,0,0,1,.233-.3.716.716,0,0,1,.193-.02q2.2,0,4.41,0a.806.806,0,0,1,.177.014.317.317,0,0,1,0,.62.869.869,0,0,1-.194.016h-2.2",
    transform: "translate(-110.195 -260.7)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22186",
    "data-name": "Path 22186",
    d: "M116.5,326.026h-2.164a1.1,1.1,0,0,1-.162-.006.321.321,0,0,1,0-.639,1.115,1.115,0,0,1,.162-.006h4.393c.264,0,.421.123.42.326s-.157.325-.421.325H116.5",
    transform: "translate(-110.173 -314.766)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22189",
    "data-name": "Path 22189",
    d: "M71.9,269.884a.326.326,0,0,1-.313.33.323.323,0,0,1-.013-.646.326.326,0,0,1,.326.316",
    transform: "translate(-68.93 -260.778)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22190",
    "data-name": "Path 22190",
    d: "M71.58,325.449a.323.323,0,0,1,0,.646.323.323,0,0,1,0-.646",
    transform: "translate(-68.932 -314.837)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeasePortfolioSetup);
export default __webpack_public_path__ + "static/media/Lease_Portfolio_Setup.f35af32756e6198685af46c1b782b744.svg";
export { ForwardRef as ReactComponent };